import React, {useEffect, useState} from 'react';
import {
  Modal,
  Select,
  Input,
  Checkbox,
  Row,
  Col,
  Collapse,
} from 'antd';
import {
  COMPETITORS,
  intialFilters,
  FILTER_OPERATOR,
} from './FilterModalConsts';
import { DatePicker } from 'antd';
import moment from 'moment';

const { Panel } = Collapse;

interface Filter {
  field: string;
  operator: FILTER_OPERATOR;
  operatorValue?: string;
  value: string | null;
  disabled?: boolean;
  placeholder?:string;
  valueOptions?: string[];
}

interface FilterModalProps {
  isModalVisible: boolean;
  handleOk: (filters:any) => void;
  handleCancel?: () => void;
  setCalculationFilters: (filter: any) => void;
  calculationFilters: any;
  filterz?: any;
}

const FilterModal: React.FC<FilterModalProps> = ({
  isModalVisible,
  handleOk,
  handleCancel,
  setCalculationFilters,
  calculationFilters,
    filterz
}) => {
  const [filters, setFiltersz] = useState<typeof intialFilters>(filterz || intialFilters);
  const [selectedCompetitor, setSelectedCompetitor] = useState<string[]>(COMPETITORS);

  useEffect(() => {
    if (filterz) {
      setFiltersz(filterz);
    }
  }, [filterz]);
  const competitors = COMPETITORS;

  // @ts-ignore
  return (
    <Modal
      width="50%"
      title="Filter"
      visible={isModalVisible}
      onOk={() => handleOk(filters)}
      onCancel={handleCancel}
    >
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <h6>By Competitor:</h6>
          <Select
            placeholder="Select competitor"
            mode="multiple"
            value={selectedCompetitor || undefined}
            onChange={(value: string[]) => {
              console.log(value);
              setSelectedCompetitor(value);
            }}
            style={{ width: '100%' }}
          >
            {competitors.map((competitor, i) => (
              <Select.Option key={i} value={competitor}>
                {competitor}
              </Select.Option>
            ))}
          </Select>
        </Col>
        <Col span={24}>
          <h6>By aggregation:</h6>
          <Collapse accordion>
            {Object.keys(filters).map((filterFamily) => (
              <Panel header={filterFamily} key={filterFamily}>
                {filters[filterFamily as keyof typeof filters].map(
                  (filter: Filter, index: number) => (
                    <Row key={index} gutter={[16, 16]} style={{ marginBottom: '5px' }} align="middle">
                      <Col span={8}>{filter.field}</Col>
                      <Col span={5} style={{ marginBottom: '0px' }}>
                        {filter.operator === FILTER_OPERATOR.STRING && (
                          <Select
                            placeholder="Operator"
                            value={filter.operatorValue || 'eq'}
                            onChange={(value: string) => {
                              const newFilter = {
                                ...filter,
                                operatorValue: value as FILTER_OPERATOR,
                              };
                              setFiltersz({
                                ...filters,
                                [filterFamily]: filters[
                                  filterFamily as keyof typeof filters
                                ].map((f, i) => (i === index ? newFilter : f)),
                              });
                            }}
                            style={{ width: '100%' }}
                            disabled={filter.disabled}
                          >
                            <Select.Option value="eq">
                              Is equal to
                            </Select.Option>
                          </Select>
                        )}
                        {filter.operator === FILTER_OPERATOR.BOOLEAN && (
                          <Checkbox
                            //@ts-ignore
                            checked={filter.value || false}
                            onChange={(e) => {
                              const newFilter = {
                                ...filter,
                                value: e.target.checked,
                              };
                              setFiltersz({
                                ...filters,
                                [filterFamily]: filters[
                                  filterFamily as keyof typeof filters
                                ].map((f, i) => (i === index ? newFilter : f)),
                              });

                            }}
                            disabled={filter.disabled}
                          ></Checkbox>
                        )}
                        {filter.operator === FILTER_OPERATOR.NUMBER && (
                          <Select
                            placeholder="Operator"
                            value={filter.operatorValue || 'eq'}
                            onChange={(value: string) => {
                              const newFilter = {
                                ...filter,
                                operatorValue: value as FILTER_OPERATOR,
                              };
                              setFiltersz({
                                ...filters,
                                [filterFamily]: filters[
                                  filterFamily as keyof typeof filters
                                ].map((f, i) => (i === index ? newFilter : f)),
                              });
                            }}
                            style={{ width: '100%' }}
                            disabled={filter.disabled}
                          >
                            <Select.Option value="eq">Equals</Select.Option>
                            <Select.Option value="gt">Greater</Select.Option>
                            <Select.Option value="gte">
                              Greater or Equal
                            </Select.Option>
                            <Select.Option value="lt">Less</Select.Option>
                            <Select.Option value="lte">
                              Less or Equal
                            </Select.Option>
                          </Select>
                        )}
                        {filter.operator === FILTER_OPERATOR.DATE && (
                          <Select
                            placeholder="Operator"
                            value={filter.operatorValue || 'after'}
                            onChange={(value: string) => {
                              const newFilter = {
                                ...filter,
                                operatorValue: value as FILTER_OPERATOR,
                              };
                              setFiltersz({
                                ...filters,
                                [filterFamily]: filters[
                                  filterFamily as keyof typeof filters
                                ].map((f, i) => (i === index ? newFilter : f)),
                              });
                            }}
                            style={{ width: '100%' }}
                            disabled={filter.disabled}
                          >
                            <Select.Option value="before">Before</Select.Option>
                            <Select.Option value="after">After</Select.Option>
                            <Select.Option value="same">Same</Select.Option>
                          </Select>
                        )}
                        {filter.operator === FILTER_OPERATOR.SELECT && (
                          <Select
                            placeholder="Operator"
                            value={filter.operatorValue || 'eq'}
                            style={{ width: '100%' }}
                            disabled={true}
                          >
                            <Select.Option value="eq">Equals</Select.Option>
                            <Select.Option value="neq">Not Equals</Select.Option>
                          </Select>
                        )}
                      </Col>
                      <Col span={8}>
                        {filter.operator === FILTER_OPERATOR.STRING && (
                          <Input
                            placeholder={filter.placeholder || "Value"}
                            value={filter.value || undefined}
                            onChange={(e) => {
                              const newFilter = {
                                ...filter,
                                value: e.target.value,
                              };
                              setFiltersz({
                                ...filters,
                                [filterFamily]: filters[
                                  filterFamily as keyof typeof filters
                                ].map((f, i) => (i === index ? newFilter : f)),
                              });
                            }}
                            style={{ width: '100%' }}
                            disabled={filter.disabled}
                          />
                        )}
                        {filter.operator === FILTER_OPERATOR.NUMBER && (
                          <Input
                              placeholder={filter.placeholder || "Value"}
                            type="number"
                            value={filter.value || undefined}
                            onChange={(e) => {
                              const newFilter = {
                                ...filter,
                                value: e.target.value,
                              };
                              setFiltersz({
                                ...filters,
                                [filterFamily]: filters[
                                  filterFamily as keyof typeof filters
                                ].map((f, i) => (i === index ? newFilter : f)),
                              });
                            }}
                            style={{ width: '100%' }}
                            disabled={filter.disabled}
                          />
                        )}
                        {filter.operator === FILTER_OPERATOR.DATE && (
                          <DatePicker
                            value={
                              filter.value ? moment(filter.value) : undefined
                            }
                            onChange={(date, dateString) => {
                              const newFilter = {
                                ...filter,
                                value: dateString,
                              };
                              setFiltersz({
                                ...filters,
                                [filterFamily]: filters[
                                  filterFamily as keyof typeof filters
                                ].map((f, i) => (i === index ? newFilter : f)),
                              });
                            }}
                            style={{ width: '100%' }}
                            disabled={filter.disabled}
                          />
                        )}
                        {filter.operator === FILTER_OPERATOR.SELECT && (
                          <>
                            <Select style={{width:'100%'}}
                                    onChange={(e) => {
                                      console.log('ELDAD',e);
                                      const newFilter = {
                                        ...filter,
                                        value: e,
                                      };
                                      setFiltersz({
                                        ...filters,
                                        [filterFamily]: filters[
                                            filterFamily as keyof typeof filters
                                            ].map((f, i) => (i === index ? newFilter : f)),
                                      });
                                    }}
                            >
                            {filter.valueOptions?.map((option) => (

                              <Select.Option key={option} value={option}>
                                {option}
                              </Select.Option>
                            ))}
                          </Select>
                              </>)}
                      </Col>
                    </Row>
                  ),
                )}
              </Panel>
            ))}
          </Collapse>
        </Col>
        <Col span={24}>
          <h6>By common fields (Advanced option):</h6>
          <Row>
            <Col span={12}>
              <Checkbox
                checked={calculationFilters['Date']}
                onChange={() =>
                  setCalculationFilters({
                    ...calculationFilters,
                    Date: !calculationFilters.Date,
                  })
                }
              >
                Date Filter
              </Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox
                checked={calculationFilters['ArrivalType']}
                onChange={() =>
                  setCalculationFilters({
                    ...calculationFilters,
                    ArrivalType: !calculationFilters.ArrivalType,
                  })
                }
              >
                ArrivalType Filter
              </Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox
                checked={calculationFilters['Destination']}
                onChange={() =>
                  setCalculationFilters({
                    ...calculationFilters,
                    Destination: !calculationFilters.Destination,
                  })
                }
              >
                Destination Filter
              </Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox
                checked={calculationFilters['Airport']}
                onChange={() =>
                  setCalculationFilters({
                    ...calculationFilters,
                    Airport: !calculationFilters.Airport,
                  })
                }
              >
                Airport Filter
              </Checkbox>
            </Col>
          </Row>
        </Col>
      </Row>
    </Modal>
  );
};

export default FilterModal;
